
module cr.entity
{
    export var entityModule: angular.IModule;

    export interface ITreeManager
    {
        currentNode : ITreeNode;
        currentPlugin : string;
        currentPluginSettings : string;

        nodes:Array<ITreeNode>;

        SetContent(route:string,sourceNode: ITreeNode, args?:any);
        AddNode(toAdd:ITreeNode,parent?:ITreeNode);
        NodeAction(treeScope:any,actionName:string);
        SearchNode(reference:Array<string>);
    }

    export interface ITreeProvider
    {
        CreateTree():ITreeManager;
    }

    export interface ITreeNode
    {
        id:string;
        collapsed:boolean;
        displayName():string;
        parent:ITreeNode;
        nodes:Array<ITreeNode>;

        TreeManager:ITreeManager;

        Action(actionName:string,args?:any);
    }


    export interface EntityModuleView  {
        Name:string;
        DisplayName:string;
        RequiredPermission:string;
    }

    export interface EntityModule extends EntityModuleView {
        Definitions: { [id: string]: EntityDefinitionView; }
    }

    export interface EntityRelationView
    {
        Name:string;
        DisplayName:string;
        AutoLoad:boolean;
        ChildDefinitionName:string;
        ParentDefinitionName:string;
    }

    export interface EntityDefinitionView
    {
        Name:string;
        DisplayName:string;
        TreeExpression:string;
        Root:boolean;
        ChildRelations: { [id: string]: EntityRelationView; }
    }

    export interface ColumnView{
        Index:number;
        Name:string;
        DisplayName:string;
    }

    export interface DynamicTable {
        Columns:Array<ColumnView>;
        Rows:Array<any>;

    }

    export interface IEntityService {
        getModules(): angular.IPromise<Array<EntityModuleView>>;
        getModuleDetail(moduleName:string): angular.IPromise<EntityModuleView>;
        //getRootEntities(moduleName:string): angular.IPromise<Array<EntityDefinitionView>>;
        create(fullPath:string): angular.IPromise<any>;
        search(fullPath:string,toSearch:string): angular.IPromise<DynamicTable>;
        getEntity(moduleName:string,entityName:string,entityId:string): angular.IPromise<any>;
        addUpdate(moduleName:string,entity:any): angular.IPromise<any>;
        getFormDefinition(moduleName:string,entityName:string):any;
    }

}
